<template>
  <div
    class="main-div"
  >
    <v-row>
      <v-col
        class="list-title"
      >
        {{ $t('road-maintenance/aggregator.rehabilitation_act_mandatory') }}
      </v-col>
    </v-row>

    <v-row>
      <v-col
        class="list-item"
      >
        {{ $t('road-maintenance/aggregator.rehabilitation_building_act') }}
      </v-col>
    </v-row>

    <v-row>
      <v-col
        class="list-item"
      >
        {{ $t('road-maintenance/aggregator.rehabilitation_contracted_cost') }}
      </v-col>
    </v-row>

    <v-row>
      <v-col
        class="list-item"
      >
        {{ $t('road-maintenance/aggregator.rehabilitation_site_manager') }}
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'RehabilitationPopup'
}
</script>

<style scoped>
.main-div {
  max-width: 563px;
  padding: 20px;
  box-shadow: 0 4px 10px rgb(148, 147, 147);
  border-radius: 12px;
  background-color: #FFFFFF;
}

.list-item {
  font-size: 16px;
  line-height: 24px;
  font-weight: 700;
  color: #09090B;
  padding: 0;
}

.list-title {
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  color: #71717A;
  margin-bottom: 10px;
  padding: 0;
}
</style>
